import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { useTrans } from 'base/utils/i18n';
import styles from './index.module.less';
import { IUseEarlyAccessResults } from '@pro/activity/testerClub/useEarlyAccessResults'
import { IAddress } from 'base/interfaces/address';
import AddressFormModal from '@base/account/address/AddressFormModal'


type IProps = {
    results: IUseEarlyAccessResults
}


const ResultsAddressForm: React.FC<IProps> = (props) => {
    const [modalState, setModalState] = useState<{
        visible: boolean;
        title?: string;
    }>({ visible: false });

    const { t } = useTrans();

    const { results } = props
    const { onAddressForm, resultsData } = results
    const { lastChanceToAddAddressTimeStamp = 0 } = resultsData || {}
    const currentTime = Math.floor(Date.now() / 1000);

    const isTimeOutAddAddress = +currentTime > +lastChanceToAddAddressTimeStamp

    const hideModal = () => {
        setModalState({ visible: false });
    };

    const openAddressForm = () => {
        setModalState({
            ...modalState,
            visible: true
        })
    }

    const onSubmitAddressForm = async (values: IAddress) => {
        await onAddressForm({
            activityGid: resultsData?.activityGid || '',
            address: values
        })
    }

    return (
        <>
            <Button
                disabled={isTimeOutAddAddress}
                className={styles.btn}
                type={'primary'}
                block
                onClick={openAddressForm}
            >{t(isTimeOutAddAddress
                ? 'web_shop_activity_eligibility_expired'
                : 'web_shop_activity_submint_shipping_address'
            )}</Button>

            <AddressFormModal
                {...modalState}
                modalFormProps={{
                    form: {
                        isDisabledSelectCountry: true
                    }
                }}
                address={{
                    countryText: resultsData?.countryText || ''
                }}
                onSubmitSelf={async (values) => {
                    await onSubmitAddressForm(values)
                    hideModal();
                }}
                onCancel={hideModal}
            />
        </>
    );
};

export default ResultsAddressForm